import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
// import TableManage from '@/product/views/Settings/TableSettings/TableManage'
import TableManage from '@/custom/components/organisms/TableSettings/TableManage'
import * as Yup from 'yup'

const BannerImage = (props) => {
    const [fieldValue, setFieldValue] = useState([
        {
            label: 'Desktop Banner Image *',
            type: 'uploadDropZone',
            accept: 'image/*',
            multiple: false,
            folder: 'banner',
            placeholder: 'Add a banner image with aspect ratio of 16:5',
            class: 'col-12',
            name: 'image',
            is_required: true,
        },
        {
            label: 'Title *',
            type: 'text',
            placeholder: 'Enter the title',
            class: 'col-12',
            name: 'title',
            isRequired: true,
        },
        {
            label: 'Description *',
            type: 'textarea',
            placeholder: 'Enter the description',
            class: 'col-12',
            name: 'description',
            isRequired: false,
        },
        {
            label: 'Title Font size *',
            type: 'number',
            placeholder: 'Enter the font size',
            class: 'col-sm-6 col-12',
            name: 'title_font_size',
            isRequired: true,
            initialDefault: 32,
        },
        {
            label: 'Description Font size *',
            type: 'number',
            placeholder: 'Enter the font size',
            class: 'col-sm-6 col-12',
            name: 'description_font_size',
            isRequired: true,
            initialDefault: 28,
        },
        {
            label: 'Title Font color',
            type: 'colorpicker',
            placeholder: 'Enter the link',
            class: 'col-sm-6 col-12',
            name: 'title_font_color',
            isRequired: false,
        },
        {
            label: 'Description Font color',
            type: 'colorpicker',
            placeholder: 'Enter the link',
            class: 'col-sm-6 col-12',
            name: 'description_font_color',
            isRequired: false,
        },
        {
            label: 'Mobile Banner Image',
            type: 'uploadDropZone',
            accept: 'image/*',
            multiple: false,
            folder: 'banner',
            placeholder: 'Add a banner image with aspect ratio of 8:5',
            class: 'col-12',
            name: 'image_mobile',
            is_required: false,
        },
        {
            label: 'Mobile Title *',
            type: 'text',
            placeholder: 'Enter the title',
            class: 'col-12',
            name: 'mobile_title',
            isRequired: true,
        },
        {
            label: 'Mobile Description *',
            type: 'textarea',
            placeholder: 'Enter the description',
            class: 'col-12',
            name: 'mobile_description',
            isRequired: false,
        },
        {
            label: 'Mobile Title Font size *',
            type: 'number',
            placeholder: 'Enter the font size',
            class: 'col-sm-6 col-12',
            name: 'mobile_title_font_size',
            isRequired: true,
            initialDefault: 32,
        },
        {
            label: 'Mobile Description Font size *',
            type: 'number',
            placeholder: 'Enter the font size',
            class: 'col-sm-6 col-12',
            name: 'mobile_description_font_size',
            isRequired: true,
            initialDefault: 28,
        },
        {
            label: 'Mobile Title Font color',
            type: 'colorpicker',
            placeholder: 'Enter the link',
            class: 'col-sm-6 col-12',
            name: 'mobile_title_font_color',
            isRequired: false,
        },
        {
            label: 'Mobile Description Font color',
            type: 'colorpicker',
            placeholder: 'Enter the link',
            class: 'col-sm-6 col-12',
            name: 'mobile_description_font_color',
            isRequired: false,
        },
        {
            label: 'Button label',
            type: 'text',
            placeholder: 'Enter the button label',
            class: 'col-sm-6 col-12',
            name: 'button_label',
            isRequired: false,
        },
        {
            label: 'Button link *',
            type: 'text',
            placeholder: 'Enter the button link',
            class: 'col-sm-6 col-12',
            name: 'link',
            isRequired: false,
        },
        {
            label: 'Button color',
            type: 'colorpicker',
            placeholder: 'Enter the link',
            class: 'col-sm-6 col-12',
            name: 'color',
            isRequired: false,
        },
        {
            label: 'Shadow',
            type: 'select',
            placeholder: 'Select Shadow',
            class: 'col-sm-6 col-12',
            name: 'shadow',
            isRequired: true,
            options: [
                { value: 'drop shadow', show: 'Drop shadow' },
                { value: 'box shadow', show: 'Box shadow' },
                { value: 'none', show: 'None' },
            ],
        },
    ])

    const validationArray = {
        title: Yup.string().max(30, 'A maximum of 30 characters is allowed!'),
        description: Yup.string().max(
            60,
            'A maximum of 60 characters is allowed!'
        ),
    }

    return (
        <Layout>
            <TableManage
                variableName="allHomeBanner"
                tableName="home_banner"
                tableHeading="Banner Image"
                customValidation={validationArray}
                arrayValue={fieldValue}
                ignoreField={{
                    enabled: 1,
                    field: 'active',
                    value: 2,
                }}
            ></TableManage>
        </Layout>
    )
}

export default BannerImage
